import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable react-hooks/exhaustive-deps */
import { CONSTANTS, BackdropLoader, BasicTooltip, getUtility, Icon, toast } from '@livable/saas-react-components';
import { ToggleButton, ToggleButtonGroup, Typography, Button, Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useOldServicePeriodConfirm } from 'src/components/allocations/OldServicePeriod';
import { billStatuses } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import AllocationForm from './AllocationForm';
import useAllocationUtilityStyles from './styles';
import { observer } from 'mobx-react-lite';
import { useOpenHelp } from 'src/components/shared/HelpCenterButton';
const AllocationUtility = observer(props => {
  var _statuses$utilityBill, _statuses$utilityBill2, _utility$bill3;
  const openHelp = useOpenHelp();
  const allocationMethod = props.allocationMethod,
    billStatus = props.billStatus,
    cycleId = props.cycleId,
    _props$expanded = props.expanded,
    expanded = _props$expanded === void 0 ? false : _props$expanded,
    fromHistory = props.fromHistory,
    isEditable = props.isEditable,
    isSkipped = props.isSkipped,
    showCorrections = props.showCorrections,
    utilityId = props.utilityId;
  const classes = useAllocationUtilityStyles();
  const history = useLocation();
  const store = useStore();
  const oldServicePeriod = useOldServicePeriodConfirm();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const queue = store.allocations.queue;
  const selectedBillingCycleId = store.allocations.selectedBillingCycleId;
  const selectedCycle = store.allocations.history.filter(cycle => cycle.id === cycleId)[0];
  const utility = store.allocations.utilityById.get(selectedBillingCycleId + utilityId) || {};
  const utilityUpdateTimestamp = store.allocations.utilityByIdTimestamp.get(selectedBillingCycleId + utilityId);
  const isDisabled = fromHistory || isEditable === false;
  const statuses = billStatuses(t);
  const utilityBillStatus = utility.billStatus || billStatus;
  const utilityProviderData = store.utilityProviders.utilities.get(utilityId);
  const utilityData = getUtility(utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.utilityTypeName);
  const urlParams = new URLSearchParams(history.search);
  const propertyId = urlParams.get('propertyId');
  const id = selectedBillingCycleId + propertyId + utilityId;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(expanded),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  const getAllocationPreview = async data => {
    const resp = await store.allocations.getAllocationPreviewAsync.run(data);
    return resp;
  };
  const postTableApproval = async data => {
    const resp = await store.allocations.postTableApprovalAsync.run(data);
    return resp;
  };
  useEffect(() => {
    if (isExpanded !== expanded) setIsExpanded(expanded);
  }, [expanded]);
  useEffect(() => {
    if (isExpanded && !store.allocations.utilityById.get(selectedBillingCycleId + utilityId)) {
      setIsLoading(id);
      store.allocations.addToQueue({
        billingCycleId: selectedBillingCycleId,
        id,
        propertyId,
        utilityId
      });
    }
  }, [isExpanded]);
  useEffect(() => {
    if (isLoading === true || isLoading === false || isLoading === 'approve') {
      postTableApproval({
        allocationCycleId: cycleId,
        billingCycleId: selectedBillingCycleId,
        isApproved: isLoading === 'approve' || null,
        isSkipped: isLoading === 'approve' ? isSkipped : isLoading,
        propertyId,
        utilityId: utilityId
      }).then(() => {
        toast('success', {
          body: ["Bill successfully ".concat(isLoading === 'approve' ? 'approved' : 'updated')]
        });
        if (isLoading === 'approve') {
          store.allocations.updateUtility(store.allocations.selectedBillingCycleId + utility.utilityId, _objectSpread(_objectSpread({}, utility), {}, {
            billStatus: 'TableReady'
          }));
        } else return getAllocationPreview({
          billingCycleId: selectedBillingCycleId,
          propertyId
        });
      }).finally(() => setIsLoading(null));
    }
  }, [isLoading]);
  useEffect(() => {
    if (!queue.find(item => item.id === id)) setIsLoading('');
  }, [queue]);

  // LB-6030: warns again before approving a long-past service period, but records nothing; the confirmation kept is
  // the one given when it was allocated.
  const handleApprove = () => {
    var _utility$bill, _utility$bill2;
    return oldServicePeriod.confirmIfOld([{
      endDateOnly: (_utility$bill = utility.bill) === null || _utility$bill === void 0 ? void 0 : _utility$bill.endDateOnly,
      startDateOnly: (_utility$bill2 = utility.bill) === null || _utility$bill2 === void 0 ? void 0 : _utility$bill2.startDateOnly
    }], () => setIsLoading('approve'), {
      confirmLabel: 'Approve',
      title: 'Approve a bill for a long-past period?'
    });
  };
  const handleHistoryPreviewOpen = () => {
    store.allocations.setHistoryData(propertyId, utilityId);
    store.allocations.setAllocationHistoryModalIsOpen(true);
  };
  const handleStatusChange = (e, value) => setIsLoading(value);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.allocationUtility
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading === true || isLoading === false
  }), /*#__PURE__*/React.createElement("div", {
    "data-tut": "reactour__allocation-table"
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isExpanded,
    onChange: () => setIsExpanded(!isExpanded)
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    className: classes.accordionSummary,
    expandIcon: isSkipped ? null : /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utility,
    "data-tut": "reactour__allocation-utility"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.utilityTitleWrapper
  }, utilityData.icon({
    svgType: 'static',
    pattern: 'gradient-inside-square'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.utilityTitle
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, utilityData.title), /*#__PURE__*/React.createElement(Typography, {
    className: classes.leftSpace,
    color: "light",
    variant: "body1"
  }, "(", utilityProviderData === null || utilityProviderData === void 0 ? void 0 : utilityProviderData.providerName, ")")), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light"
  }, t('allocations.allocated_by'), " ", CONSTANTS.ALLOCATION_METHODS[allocationMethod]))), /*#__PURE__*/React.createElement("div", {
    className: classes.flex,
    onClick: e => e.stopPropagation()
  }, !isSkipped && utilityBillStatus ? /*#__PURE__*/React.createElement("div", {
    className: classes.utilityBillStatus
  }, /*#__PURE__*/React.createElement(Chip, {
    label: (_statuses$utilityBill = statuses[utilityBillStatus]) === null || _statuses$utilityBill === void 0 ? void 0 : _statuses$utilityBill.label,
    size: "large",
    variant: (_statuses$utilityBill2 = statuses[utilityBillStatus]) === null || _statuses$utilityBill2 === void 0 ? void 0 : _statuses$utilityBill2.variant
  })) : null, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    className: classes.billToggle,
    exclusive: true,
    onChange: handleStatusChange,
    size: "small",
    value: isSkipped
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    disabled: isDisabled,
    value: false
  }, t('allocations.actual_bill')), /*#__PURE__*/React.createElement(ToggleButton, {
    disabled: isDisabled,
    value: true
  }, t('allocations.skip_bill'))), /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('add_new_property_flow.more_details_at_help_center'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.infoButton,
    onClick: () => openHelp('allocation method'),
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '503-allocation-utility'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "question",
    state: "info"
  }))), /*#__PURE__*/React.createElement(BasicTooltip, {
    title: t('allocations.utility_allocation_history_preview'),
    placement: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleHistoryPreviewOpen,
    size: "small",
    variant: "actionIcon",
    'custom-attribute': '507-allocation-utility'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "bar-chart"
  })))))), /*#__PURE__*/React.createElement(AccordionDetails, null, isSkipped ? null : /*#__PURE__*/React.createElement(AllocationForm, {
    billId: ((_utility$bill3 = utility.bill) === null || _utility$bill3 === void 0 ? void 0 : _utility$bill3.id) || '',
    fromHistory: fromHistory,
    fetchDefaultChargeOnDate: store.company.companyFeatureStore.isAppfolio && isExpanded,
    handleApprove: handleApprove,
    showCorrections: showCorrections,
    isUtilityLoading: isLoading,
    propertyId: propertyId,
    selectedCycleStartDate: selectedCycle === null || selectedCycle === void 0 ? void 0 : selectedCycle.startDateOnly,
    utility: utility,
    utilityBillStatus: utilityBillStatus,
    utilityName: utilityData.title,
    utilityUpdateTimestamp: utilityUpdateTimestamp
  })))), oldServicePeriod.confirmation);
});
export default AllocationUtility;